// extracted by mini-css-extract-plugin
export default {"checkboxLabel":"Checkbox_checkboxLabel__-NK9y","checkboxLabelText":"Checkbox_checkboxLabelText__jlO7i"};